import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'

import Icon from 'components/_new/ui/Icon/Icon'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import messages from './messages'
import s from './QueueBanner.scss'

import arrowIcon from './images/arrow.svg'


class QueueBanner extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
  }

  handleClick = () => {
    actions.models.modals.open(constants.modals.HowQueueWorks)
  }

  render() {
    const { onClose } = this.props

    return (
      <div className={s.banner}>
        <WidthContainer>
          <div className={s.content}>
            <button className={s.closeButton} onClick={onClose} type="button">
              <Icon name="closeLight" />
            </button>
            <Text
              className={s.title}
              message={messages.title}
              html
            />
            <Text
              className={s.subTitle}
              message={messages.subTitle}
              tag="button"
              color="brand"
              onClick={this.handleClick}
            />
            <img className={s.arrow} src={arrowIcon} alt="" />
          </div>
        </WidthContainer>
      </div>
    )
  }
}


export default QueueBanner
